export const enum NativeMessageType {
  TRACK_AMPLITUDE_EVENT = 'TRACK_AMPLITUDE_EVENT',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  GET_INITIAL_DATA = 'GET_INITIAL_DATA',
  ON_CLOSE = 'ON_CLOSE',
  ERROR = 'ERROR'
}
